import { useCallback } from 'react';
import { Recipe } from '../../api/Recipe';

interface UseFavoriteToggleActionParams {
  isFavorite: (recipeId: string) => boolean;
  addFavorite: (recipe: Recipe) => Promise<void>;
  removeFavorite: (recipeId: string) => Promise<void>;
  showToast: (message: string, type?: 'success' | 'error' | 'info') => void;
  successMessages?: {
    added: string;
    removed: string;
  };
  errorMessage?: string;
}

const DEFAULT_SUCCESS_MESSAGES = {
  added: 'Recette ajoutee aux favoris',
  removed: 'Recette retiree des favoris',
};

const DEFAULT_ERROR_MESSAGE = 'Impossible de mettre a jour les favoris.';

export const useFavoriteToggleAction = ({
  isFavorite,
  addFavorite,
  removeFavorite,
  showToast,
  successMessages = DEFAULT_SUCCESS_MESSAGES,
  errorMessage = DEFAULT_ERROR_MESSAGE,
}: UseFavoriteToggleActionParams) => {
  return useCallback(async (recipe: Recipe): Promise<void> => {
    try {
      if (isFavorite(recipe.id)) {
        await removeFavorite(recipe.id);
        showToast(successMessages.removed, 'info');
        return;
      }

      await addFavorite(recipe);
      showToast(successMessages.added, 'success');
    } catch (error: any) {
      showToast(error?.message || errorMessage, 'error');
    }
  }, [
    addFavorite,
    errorMessage,
    isFavorite,
    removeFavorite,
    showToast,
    successMessages.added,
    successMessages.removed,
  ]);
};

export default useFavoriteToggleAction;
